/**
 * Berndorf — Produktseite: Galerie und Mengen-Stepper.
 *
 * Beides läuft über Delegation am document. Der Stepper muss auch in Markup
 * funktionieren, das erst zur Laufzeit aus einem <template> geklont wird
 * (Quickview) — ein Listener je Instanz würde das nicht abdecken.
 */
(function () {
  'use strict';

  /* ---------------------------------------------------------------- Stepper */

  function stepperInput(scope) {
    return scope ? scope.querySelector('[data-berndorf-stepper-input]') : null;
  }

  function clamp(input, next) {
    var min = input.hasAttribute('min') ? parseInt(input.getAttribute('min'), 10) : 0;
    var max = input.hasAttribute('max') ? parseInt(input.getAttribute('max'), 10) : null;

    if (isNaN(min)) min = 0;
    if (next < min) next = min;
    if (max !== null && !isNaN(max) && next > max) next = max;
    return next;
  }

  function step(button, delta) {
    var scope = button.closest('[data-berndorf-stepper]');
    var input = stepperInput(scope);
    if (!input) return;

    var current = parseInt(input.value, 10);
    if (isNaN(current)) current = 0;

    input.value = clamp(input, current + delta);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('click', function (event) {
    var up = event.target.closest('[data-berndorf-stepper-up]');
    if (up) {
      step(up, 1);
      return;
    }

    var down = event.target.closest('[data-berndorf-stepper-down]');
    if (down) {
      step(down, -1);
    }
  });

  /* Getippte Werte normalisieren — leer, negativ oder Text darf nicht in den
     Warenkorb-Request wandern. */
  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-berndorf-stepper-input]');
    if (!input) return;

    var value = parseInt(input.value, 10);
    if (isNaN(value)) value = parseInt(input.getAttribute('min'), 10) || 0;
    input.value = clamp(input, value);
  });

  /* ---------------------------------------------------------------- Galerie */

  function activate(gallery, index) {
    var slides = gallery.querySelectorAll('[data-berndorf-gallery-slide]');
    var thumbs = gallery.querySelectorAll('[data-berndorf-gallery-thumb]');

    slides.forEach(function (slide) {
      var isActive = slide.getAttribute('data-berndorf-gallery-slide') === index;
      slide.classList.toggle('is-active', isActive);

      if (isActive) {
        slide.removeAttribute('aria-hidden');
      } else {
        slide.setAttribute('aria-hidden', 'true');

        /* Ein Video, von dem weggeschaltet wird, spielt sonst unsichtbar
           weiter — samt Ton. */
        var media = slide.querySelector('video, iframe');
        if (media && typeof media.pause === 'function') {
          media.pause();
        }
      }
    });

    thumbs.forEach(function (thumb) {
      var isActive = thumb.getAttribute('data-berndorf-gallery-thumb') === index;
      thumb.classList.toggle('is-active', isActive);
      if (isActive) {
        thumb.setAttribute('aria-current', 'true');
      } else {
        thumb.removeAttribute('aria-current');
      }
    });

    /* Steht ein Video vorne, gibt es nichts zu vergroessern — der Zoom-Knopf
       verschwindet, statt eine Lightbox ohne Inhalt zu versprechen. */
    var zoom = gallery.querySelector('[data-berndorf-lightbox-open]');
    if (zoom) zoom.hidden = !activeImage(gallery);
  }

  function activeImage(gallery) {
    var slide = gallery.querySelector('[data-berndorf-gallery-slide].is-active');
    return slide ? slide.querySelector('img[data-berndorf-full]') : null;
  }

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-berndorf-gallery-thumb]');
    if (!thumb) return;

    var gallery = thumb.closest('[data-berndorf-gallery]');
    if (!gallery) return;

    activate(gallery, thumb.getAttribute('data-berndorf-gallery-thumb'));
  });

  /* --------------------------------------------------------------- Lightbox
     Die Buehne schneidet quadratisch zu (`object-fit: cover`); die Lightbox
     zeigt dasselbe Medium ungeschnitten und gross. Sie fuehrt keine eigene
     Liste: Quelle bleibt die Galerie, geblaettert wird ueber `activate()` —
     dadurch steht hinter der Lightbox immer das Bild, das man zuletzt gesehen
     hat, samt passendem Thumbnail. */

  var lightbox = {
    root: null,
    dialog: null,
    figure: null,
    image: null,
    counter: null,
    prev: null,
    next: null,
    gallery: null,
    opener: null
  };

  function ensureLightbox() {
    if (lightbox.root) return lightbox.root;

    lightbox.root = document.querySelector('[data-berndorf-lightbox]');
    if (!lightbox.root) return null;

    lightbox.dialog = lightbox.root.querySelector('.berndorf-lightbox__dialog');
    lightbox.figure = lightbox.root.querySelector('.berndorf-lightbox__figure');
    lightbox.image = lightbox.root.querySelector('[data-berndorf-lightbox-image]');
    lightbox.counter = lightbox.root.querySelector('[data-berndorf-lightbox-counter]');
    lightbox.prev = lightbox.root.querySelector('[data-berndorf-lightbox-prev]');
    lightbox.next = lightbox.root.querySelector('[data-berndorf-lightbox-next]');

    /* Einmal gebunden, nicht je Bildwechsel — sonst sammeln sich die Listener.
       `error` zaehlt wie `load`: ein Spinner, der ewig dreht, ist schlechter
       als ein leeres Feld. */
    lightbox.image.addEventListener('load', function () { setLoading(false); });
    lightbox.image.addEventListener('error', function () { setLoading(false); });

    return lightbox.root;
  }

  /* Liegt der Klick ausserhalb der tatsaechlich gezeichneten Bildflaeche?
     `contain` skaliert auf den kleineren der beiden Faktoren und zentriert. */
  function besideImage(event) {
    var img = lightbox.image;
    if (!img || !img.naturalWidth || !img.naturalHeight) return true;

    var box = img.getBoundingClientRect();
    var scale = Math.min(box.width / img.naturalWidth, box.height / img.naturalHeight);
    var width = img.naturalWidth * scale;
    var height = img.naturalHeight * scale;
    var left = box.left + (box.width - width) / 2;
    var top = box.top + (box.height - height) / 2;

    return event.clientX < left || event.clientX > left + width ||
      event.clientY < top || event.clientY > top + height;
  }

  function setLoading(on) {
    if (!lightbox.figure) return;
    lightbox.figure.classList.toggle('is-loading', on);
    lightbox.figure.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  /* Nachbarn vorladen. Das ist der eigentliche Grund, warum das Blättern
     stockte: jedes Bild wurde erst beim Klick geholt. Der Spinner erklaert die
     Wartezeit, das Vorladen nimmt sie weg. Geholt wird mit demselben `srcset`
     und `sizes` wie am sichtbaren Bild — sonst waehlt der Browser dort einen
     anderen Kandidaten und der Vorrat im Cache passt nicht. */
  var preloaded = {};

  function preloadNeighbours(gallery, slide) {
    var slides = imageSlides(gallery);
    if (slides.length < 2) return;

    var at = slides.indexOf(slide);
    [at + 1, at - 1].forEach(function (index) {
      var neighbour = slides[(index + slides.length) % slides.length];
      var source = neighbour && neighbour.querySelector('img[data-berndorf-full]');
      if (!source) return;

      var url = source.getAttribute('data-berndorf-full');
      if (!url || preloaded[url]) return;
      preloaded[url] = true;

      var pre = new Image();
      pre.sizes = lightbox.image.getAttribute('sizes') || '';
      pre.srcset = source.getAttribute('data-berndorf-full-srcset') || '';
      pre.src = url;
    });
  }

  /* Nur Bild-Slides, in Reihenfolge der Galerie. */
  function imageSlides(gallery) {
    return Array.prototype.filter.call(
      gallery.querySelectorAll('[data-berndorf-gallery-slide]'),
      function (slide) { return !!slide.querySelector('img[data-berndorf-full]'); }
    );
  }

  function showInLightbox(gallery, slide) {
    var source = slide && slide.querySelector('img[data-berndorf-full]');
    if (!source) return false;

    /* srcset zuerst leeren: der Browser behaelt sonst den alten Kandidaten,
       solange das neue src noch nicht entschieden ist, und zeigt kurz das
       vorige Bild. */
    lightbox.image.removeAttribute('srcset');
    lightbox.image.src = source.getAttribute('data-berndorf-full');
    lightbox.image.setAttribute('srcset', source.getAttribute('data-berndorf-full-srcset') || '');
    lightbox.image.alt = source.getAttribute('alt') || '';

    /* Liegt es schon im Cache, ist es hier bereits fertig — dann gar nicht
       erst einen Spinner zeigen, der sofort wieder verschwindet. */
    setLoading(!(lightbox.image.complete && lightbox.image.naturalWidth > 0));
    preloadNeighbours(gallery, slide);

    var slides = imageSlides(gallery);
    var position = slides.indexOf(slide) + 1;
    var many = slides.length > 1;

    if (lightbox.prev) lightbox.prev.hidden = !many;
    if (lightbox.next) lightbox.next.hidden = !many;
    if (lightbox.counter) {
      lightbox.counter.hidden = !many;
      lightbox.counter.textContent = many ? counterText(position, slides.length) : '';
    }

    return true;
  }

  /* Platzhalter-Konvention wie bei `nachkauf_success_other` — die Zahl steht
     im Locale, nicht im Skript. */
  function counterText(position, total) {
    var template = lightbox.counter.getAttribute('data-template') || '__INDEX__ / __TOTAL__';
    return template.replace('__INDEX__', position).replace('__TOTAL__', total);
  }

  function openLightbox(button) {
    var gallery = button.closest('[data-berndorf-gallery]');
    if (!gallery || !ensureLightbox()) return;

    var slide = gallery.querySelector('[data-berndorf-gallery-slide].is-active');
    if (!showInLightbox(gallery, slide)) return;

    lightbox.gallery = gallery;
    lightbox.opener = button;
    lightbox.root.hidden = false;
    document.documentElement.classList.add('berndorf-lightbox-open');
    lightbox.dialog.focus();
  }

  function closeLightbox() {
    if (!lightbox.root || lightbox.root.hidden) return;

    lightbox.root.hidden = true;
    /* Das grosse Bild wieder freigeben — sonst haelt die geschlossene
       Lightbox es bis zum Seitenwechsel im Speicher. */
    lightbox.image.removeAttribute('srcset');
    lightbox.image.removeAttribute('src');
    setLoading(false);
    lightbox.gallery = null;
    document.documentElement.classList.remove('berndorf-lightbox-open');

    if (lightbox.opener) {
      lightbox.opener.focus();
      lightbox.opener = null;
    }
  }

  function stepLightbox(delta) {
    if (!lightbox.gallery) return;

    var slides = imageSlides(lightbox.gallery);
    if (slides.length < 2) return;

    var current = lightbox.gallery.querySelector('[data-berndorf-gallery-slide].is-active');
    var at = slides.indexOf(current);
    if (at === -1) at = 0;

    var target = slides[(at + delta + slides.length) % slides.length];
    activate(lightbox.gallery, target.getAttribute('data-berndorf-gallery-slide'));
    showInLightbox(lightbox.gallery, target);
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-berndorf-lightbox-close]')) {
      closeLightbox();
      return;
    }

    /* Klick neben das Bild schliesst. Das laesst sich nicht am Klickziel
       ablesen: das <img> fuellt die ganze Flaeche, und `object-fit: contain`
       laesst nur *durchsichtige* Raender stehen — ein Klick dort trifft immer
       noch das Bild-Element. Also wird nachgerechnet, wo das Foto wirklich
       liegt. Auf das Foto selbst zu klicken schliesst bewusst nicht. */
    if (lightbox.root && !lightbox.root.hidden &&
        event.target.closest('[data-berndorf-lightbox]') &&
        !event.target.closest('button') &&
        besideImage(event)) {
      closeLightbox();
      return;
    }

    if (event.target.closest('[data-berndorf-lightbox-prev]')) {
      stepLightbox(-1);
      return;
    }

    if (event.target.closest('[data-berndorf-lightbox-next]')) {
      stepLightbox(1);
      return;
    }

    var opener = event.target.closest('[data-berndorf-lightbox-open]');
    if (opener) {
      openLightbox(opener);
      return;
    }

    /* Maus-Abkuerzung: Klick auf das grosse Bild oeffnet ebenfalls. Der
       Zoom-Knopf derselben Galerie dient dabei als Oeffner, damit der Fokus
       beim Schliessen an einem bedienbaren Element landet. */
    var slide = event.target.closest('.berndorf-product-gallery__slide--image');
    if (!slide) return;

    var gallery = slide.closest('[data-berndorf-gallery]');
    var zoom = gallery && gallery.querySelector('[data-berndorf-lightbox-open]');
    if (zoom) openLightbox(zoom);
  });

  /* Die erste Slide ist schon beim Rendern aktiv — `activate` laeuft dort nie
     und haette den Zoom-Knopf einer Video-Galerie stehen lassen. */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-berndorf-gallery]').forEach(function (gallery) {
      var zoom = gallery.querySelector('[data-berndorf-lightbox-open]');
      if (zoom) zoom.hidden = !activeImage(gallery);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (!lightbox.root || lightbox.root.hidden) return;

    if (event.key === 'Escape') {
      closeLightbox();
      return;
    }

    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      stepLightbox(-1);
      return;
    }

    if (event.key === 'ArrowRight') {
      event.preventDefault();
      stepLightbox(1);
      return;
    }

    /* `aria-modal` behauptet, ausserhalb sei nichts — der Tabulator muss sich
       daran halten, sonst wandert der Fokus hinter die Lightbox. */
    if (event.key !== 'Tab') return;

    var stops = Array.prototype.filter.call(
      lightbox.dialog.querySelectorAll('button'),
      function (node) { return !node.hidden && node.offsetParent !== null; }
    );
    if (!stops.length) {
      event.preventDefault();
      lightbox.dialog.focus();
      return;
    }

    var first = stops[0];
    var last = stops[stops.length - 1];
    var active = document.activeElement;

    if (event.shiftKey && (active === first || active === lightbox.dialog)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  });

  /* ------------------------------------------------- Ausführung-Umschalter
     Wechselt Variante, Preis, Untertitel, Galeriebild und URL — und meldet
     die neue Ausführung als Event, damit die Nachkauf-Zeilen mitwechseln
     (berndorf-product-nachkauf.js). Daten kommen aus dem JSON-Block der
     Section; Preise sind dort von Liquid formatiert, hier wird nur Text
     getauscht. */

  var variantData = null;

  function variants() {
    if (variantData) return variantData;
    var block = document.querySelector('[data-berndorf-variants]');
    if (!block) return [];
    try {
      variantData = JSON.parse(block.textContent);
    } catch (error) {
      variantData = [];
    }
    return variantData;
  }

  /* Ausführung, die nur Teile der Serie führen, das Set selbst nicht
     (Swing: CR, Menuett: Sterling Silber).
     Das Set ist darin nicht kaufbar: Preis und Warenkorb treten zurück, ein
     Hinweis erklärt warum, und die Teile-Liste öffnet sich in dieser
     Ausführung. Die Teile ohne sie blendet die Liste aus. */
  function setPieceOnly(section, title) {
    if (!section) return;
    section.classList.toggle('is-piece-only', !!title);
    var note = section.querySelector('[data-berndorf-piece-only-note]');
    if (note) note.hidden = !title;
  }

  function showPieceOnly(section, title) {
    var subtitle = section && section.querySelector('[data-berndorf-subtitle]');
    var pill = section && section.querySelector('[data-piece-only="' + CSS.escape(title) + '"] + span');
    if (subtitle) subtitle.textContent = pill ? pill.textContent.trim() : title;

    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, '', window.location.pathname);
    }

    var nachkauf = section && section.querySelector('[data-berndorf-nachkauf]');
    if (nachkauf) nachkauf.open = true;

    document.dispatchEvent(new CustomEvent('berndorf:ausfuehrung', {
      detail: { id: null, title: title, pieceOnly: true },
    }));
  }

  document.addEventListener('change', function (event) {
    var picker = event.target.closest('[data-berndorf-ausfuehrung]');
    if (!picker || event.target.type !== 'radio') return;

    var section = picker.closest('.berndorf-product');
    var pieceOnly = event.target.getAttribute('data-piece-only');
    setPieceOnly(section, pieceOnly);
    if (pieceOnly) {
      showPieceOnly(section, pieceOnly);
      return;
    }

    var id = parseInt(event.target.value, 10);
    var variant = variants().find(function (v) { return v.id === id; });
    if (!variant) return;

    var idInput = section && section.querySelector('input.product-variant-id');
    if (idInput) {
      idInput.value = variant.id;
      idInput.disabled = !variant.available;
    }

    var submit = section && section.querySelector('.berndorf-product__submit');
    if (submit) submit.disabled = !variant.available;

    var price = section && section.querySelector('[data-berndorf-price] .price-item--regular');
    if (price) price.textContent = variant.price;

    var subtitle = section && section.querySelector('[data-berndorf-subtitle]');
    if (subtitle) subtitle.textContent = variant.display_title || variant.title;

    if (variant.media_id) {
      var slide = section && section.querySelector(
        '[data-berndorf-gallery-slide][data-media-id="' + variant.media_id + '"]'
      );
      var gallery = slide && slide.closest('[data-berndorf-gallery]');
      if (gallery) {
        activate(gallery, slide.getAttribute('data-berndorf-gallery-slide'));
      }
    }

    /* Die Standard-Ausführung braucht keinen Parameter: ohne `?variant=`
       rendert Shopify ohnehin die erste verfügbare Variante. Das hält die
       häufigste URL sauber (/products/avantgarde-tafelgabel), und die
       kryptische ID erscheint nur, wenn jemand aktiv eine andere Ausführung
       wählt. Zurückschalten räumt sie wieder weg.

       Ein *lesbarer* Parameter statt der ID ginge nicht: Shopify-Liquid kann
       keine Query-Parameter lesen, der Server würde also immer die
       Standardvariante ausliefern und erst JS nachkorrigieren. */
    if (window.history && window.history.replaceState) {
      var list = variants();
      var fallback = list.filter(function (v) { return v.available; })[0] || list[0];
      var isDefault = fallback && fallback.id === variant.id;
      var path = (variant.url || window.location.pathname).split('?')[0];
      window.history.replaceState({}, '', isDefault ? path : path + '?variant=' + variant.id);
    }

    document.dispatchEvent(new CustomEvent('berndorf:ausfuehrung', {
      detail: { id: variant.id, title: variant.title },
    }));

    refreshSections(section, variant.id);
  });

  /* ------------------------------------------- Sections neu rendern
     Spec-Tabelle und „Auf einen Blick" liegen in eigenen Sections weiter
     unten und lesen die Metafelder der **gewählten Variante**. Der Umschalter
     oben kann sie darum nicht per Textaustausch aktualisieren — sie werden
     über die Section Rendering API frisch geholt.

     Welche Sections das sind, sagen sie selbst über
     `[data-berndorf-variant-section]`. Der Marker steht im Liquid außerhalb
     der Sichtbarkeitsbedingung, damit auch eine Section zurückkommen kann,
     die für die vorige Ausführung nichts gerendert hat. */

  var refreshToken = 0;

  function refreshSections(scope, variantId) {
    var root = scope || document;
    var url = (root.closest && root.closest('[data-product-url]')) ||
      document.querySelector('[data-product-url]');
    url = url && url.getAttribute('data-product-url');
    if (!url) return;

    var markers = document.querySelectorAll('[data-berndorf-variant-section]');
    if (!markers.length) return;

    refreshToken += 1;
    var token = refreshToken;

    markers.forEach(function (marker) {
      var id = marker.getAttribute('data-berndorf-variant-section');
      var target = document.getElementById('shopify-section-' + id);
      if (!target) return;

      fetch(url + '?variant=' + variantId + '&section_id=' + id)
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then(function (text) {
          /* Schnelles Umschalten erzeugt mehrere Anfragen — nur die Antwort
             zur zuletzt gewählten Variante darf gewinnen, sonst gewinnt die
             langsamste. */
          if (token !== refreshToken) return;

          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.getElementById('shopify-section-' + id);
          if (!fresh) return;

          target.innerHTML = fresh.innerHTML;
          document.dispatchEvent(new CustomEvent('berndorf:section-replaced', {
            detail: { id: id, section: target },
          }));
        })
        .catch(function () {
          /* Bleibt die alte Fassung stehen: sie ist veraltet, aber nicht
             falsch aussehend — besser als ein leerer Abschnitt. */
        });
    });
  }
})();
